import { Transform, Type } from 'class-transformer';
import { temporalPlainDateTransformer } from 'src/lib/utilities/api/class-transformer-types';
import {
	PagingSearchFieldArgument,
	PagingSearchFieldArrayArgument,
} from 'src/lib/utilities/api/patterns/pagination/paging-search-field.argument';

export class ClassroomsSearchModel {
	id: number;
	classroom_name: string;
	classroom_status: ClassroomStatusType;
	session_id: number;
	session_name: string;
	session_status: ClassroomSessionStatusType;
	start_time: string;
	end_time: string;
	session_registration_start_timestamp: number;
	@Transform(temporalPlainDateTransformer)
	session_registration_start_date: Temporal.PlainDate;
	session_registration_end_timestamp: number;
	@Transform(temporalPlainDateTransformer)
	session_registration_end_date: Temporal.PlainDate;
	timezone: string;
	status: ClassroomStatusType;
	student_count: number;
	program_count: number;
}

export function ClassroomsSearchModel_ClassTransform_Type() {
	return ClassroomsSearchModel;
}

export class ClassroomsSearchResultsModel {
	@Type(ClassroomsSearchModel_ClassTransform_Type)
	results: ClassroomsSearchModel[];
	count: number;
}

export interface ClassroomSearchArgument {
	id: PagingSearchFieldArgument;
	classroom_name: PagingSearchFieldArgument;
	classroom_status: PagingSearchFieldArrayArgument | PagingSearchFieldArgument;
	session_id: PagingSearchFieldArgument;
	session_name: PagingSearchFieldArgument;
	session_status: PagingSearchFieldArrayArgument;
	start_date: PagingSearchFieldArgument;
	end_date: PagingSearchFieldArgument;
	session_registration_start_date: PagingSearchFieldArgument;
	session_registration_end_date: PagingSearchFieldArgument;
	timezone: PagingSearchFieldArgument;
	status: PagingSearchFieldArgument;
	program_id: PagingSearchFieldArgument;
	student_count: PagingSearchFieldArgument;
	program_count: PagingSearchFieldArgument;
}

export type ClassroomModalTypes = 'create' | 'edit' | 'view';

export enum ClassroomSessionStatusTitleEnum {
	pending = 'Draft',
	activated = 'Activated',
	archived = 'Archived',
}

export type ClassroomSessionStatusType = 'pending' | 'activated' | 'archived';

export enum ClassroomStatusTitleEnum {
	draft = 'Draft',
	active = 'Activated',
	archived = 'Archived',
}

export type ClassroomStatusType = 'draft' | 'active' | 'archived';
